import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { QuoteIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-12 bg-leaf text-white" data-id="element-162">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-163">
        <FadeIn data-id="element-164">
          <QuoteIcon className="w-12 h-12 text-forest/40 mx-auto mb-8 rotate-180" data-id="element-165" />
          <p className="text-2xl md:text-3xl font-medium leading-tight mb-10 text-cream" data-id="element-166">
            "En solo 7 días aplicando el Escudo Metabólico, la mayoría de los
            padres reportan una reducción drástica en la hiperactividad nocturna
            y el fin de los berrinches causados por caídas de azúcar."
          </p>
          <div className="inline-block bg-forest px-6 py-3 rounded-full font-bold tracking-wide text-sm uppercase" data-id="element-167">
            Es el cambio de "llenar un estómago" a "formar un cerebro".
          </div>
        </FadeIn>
      </div>
    </section>;
}